module.exports = __webpack_public_path__ + "static/media/emailToPay-gray.8b40a84d.png";